export const CONFIRM_DIALOG_LABELS = {
  HEADER: 'Cancel File Upload',
  FOLLOWING_FILE: 'The following file will not be submitted:',
  BACK: 'Back',
  CONFIRM: 'Confirm',
};
